module.exports = __webpack_public_path__ + "media/customizations/regencyatesperanza/logo-new-0db9d2fdb53c6245166811bddeb57b46.png";